import { serializable, primitive, alias } from 'serializr';

export class OrganizationYearWise {
  @serializable(primitive())
  id?: number;

  @serializable(alias('parent_name', primitive()))
  parentName?: string | null;

  @serializable(alias('is_parent', primitive()))
  isParent?: boolean;

  @serializable(alias('is_active', primitive()))
  isActive?: boolean;

  @serializable(alias('organization_share', primitive()))
  organizationShare?: number;

  @serializable(alias('total_locations', primitive()))
  totalLocations?: number;

  @serializable(primitive())
  year?: number;

  //Used for FE purpose only, to avoid multiple iterative loops
  parentIndex?: number;
}
